import Vuetify from 'vuetify/lib'

import * as values from '../icons/mdi'
import { colors } from '../themes/tokens'
import { injectIcons } from './injectIcons'
import * as filters from '~/filters'

export const minifyTheme = css => css
  .replace(/\n\s?|\s(?=[\w!#\-{])/g, '')
  .replace(/\s{2,}/g, ' ')

export const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values
  },
  theme: {
    themes: { light: colors },
    options: {
      customProperties: true,
      minifyTheme
    }
  }
})

export const framework = vuetify.framework

export default {
  install (Vue, config = {}) {
    framework.icons.values = {
      ...framework.icons.values,
      ...config.icons
    }
    Vue.prototype.$device = {
      isMobile: framework.breakpoint.mobile
    }
    Vue.use(Vuetify)
    Object.keys(filters).forEach(filter => {
      if (typeof filters[filter] !== 'function') return
      Vue.filter(filter, filters[filter])
    })
  }
}

export const addIcons = injectIcons(framework)
